import { useCountyTiles } from '../../hooks/useCountyTiles';

/**
 * Component to load and display county-based survey polygon tiles.
 * Only renders counties visible in current viewport at appropriate zoom level.
 * Uses manifest file for efficient spatial lookup.
 */
const CountyTiles = ({ 
  visible = true, 
  minZoom = 11,
  tileLayer = 'default', // 'default' | 'satellite'
  style = {
    fillColor: 'transparent',
    fillOpacity: 0,
    color: '#5a7a7a', // One shade lighter than county boundaries (#2f4f4f)
    weight: 1,
    opacity: 0.9
  }
}) => {
  useCountyTiles({
    manifestPath: '/geodata/tx_survey_polygons_counties/manifest.json',
    basePath: '/geodata/tx_survey_polygons_counties/',
    visible: visible,
    minZoom: minZoom,
    tileLayer: tileLayer,
    style: style,
    onEachFeature: null // No custom handler - labels handled in hook, no popups
  });

  return null; // Component doesn't render anything directly
};

export default CountyTiles;

